export default {"src":"/_next/static/media/apple.9301aaf7.svg","height":23,"width":15};